import React from "react";
import { ButtonGroup, Button } from "reactstrap";

const TYPES = [
  { value: "area", icon: "area_chart", label: "Área" },
  { value: "line", icon: "show_chart", label: "Línea" },
  { value: "bar", icon: "bar_chart", label: "Barras" },
];

const ChartTypeToggle = ({ value, onChange, className = "" }) => (
  <ButtonGroup size="sm" className={className}>
    {TYPES.map((t) => (
      <Button
        key={t.value}
        color={value === t.value ? "primary" : "light"}
        onClick={() => onChange(t.value)}
        title={t.label}
        style={{ minWidth: 34, padding: "2px 6px" }}
      >
        <span className="material-symbols-rounded" style={{ fontSize: 16 }}>
          {t.icon}
        </span>
      </Button>
    ))}
  </ButtonGroup>
);

export default ChartTypeToggle;
